const navActionTypes = {
  TOGGLE_NAVBAR: 'TOGGLE_NAVBAR',
  SET_ACTIVE_LINK: 'SET_ACTIVE_LINK'
}

export default navActionTypes;